const components = {
  form: {
    title: 'Form und Maße',
    titleId: 'kub-form-heading',
    toggle: 'kub-form',
    comp: 'app-form',
    visible: true,
    id: 1
  },
  material: {
    title: 'Material und Farbe',
    titleId: 'kub-material-heading',
    toggle: 'kub-material',
    comp: 'app-material',
    visible: false,
    id: 2
  },
  rand: {
    title: 'Randgestaltung',
    titleId: 'kub-rand-heading',
    toggle: 'kub-rand',
    comp: 'app-rand',
    visible: false,
    id: 3
  }
}

export default {
  components
}
